// extracted by mini-css-extract-plugin
export default {"name":"UserDetails_name__xovqr"};